"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.t = exports.loadLocale = void 0;
const toastr_1 = __importDefault(require("toastr"));
const settings_1 = require("~/settings");
const sentry_1 = require("./sentry");
let translations = {};
function loadLocale(locale) {
    return __awaiter(this, void 0, void 0, function* () {
        var url = [settings_1.settings.baseUrl, settings_1.settings.localesUrl, locale, '.json'].join('');
        try {
            const res = yield fetch(url);
            const data = yield res.json();
            console.log('Locale is ', locale);
            translations = data;
        }
        catch (err) {
            toastr_1.default.error("Oups, technical error...");
            console.error(err);
            (0, sentry_1.captureException)(err);
        }
    });
}
exports.loadLocale = loadLocale;
function t(key) {
    return translations[key];
}
exports.t = t;
